import React, { useCallback, useMemo } from 'react';
import { Card } from "../../../../components/Card/Card";
import { Checkbox } from "../../../../components/Checkbox/Checkbox";
import { Typography } from "../../../../components/Typography/Typography";
import { pathToWorkPreview } from "../../../../helpers/route-helpers";
import { makeStyles } from "../../../../styles/index";
import { getDisplaySubjectInfoByDrillTypeName } from "../../utils/Drill";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        minHeight: 48,
        display: 'flex',
        textDecoration: 'none',
        backgroundColor: theme.palette.common.white,
        cursor: 'pointer',
        boxShadow: 'none',
        borderRadius: 0,
    },
    content: {
        flex: '1 0 0',
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.common.black,
    },
    subjectMark: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        '& > svg': {
            width: 32,
            height: 32,
        },
    },
    title: {
        flex: '1 0 0%',
        maxWidth: 640,
    },
    titleSpan: {
        padding: theme.spacing(0, 3),
        display: 'flex',
    },
    info: {
        marginLeft: 'auto',
    },
    infoRow: {
        display: 'flex',
    },
    infoLabel: {
        width: 56,
        marginRight: theme.spacing(1),
    },
    infoValue: {
        width: 150,
    },
    checkbox: {
        paddingRight: theme.spacing(2),
    },
}); }, { name: 'SnWorkItem' });
export var WorkItem = React.memo(function (props) {
    var id = props.id, name = props.name, drillType = props.drillType, isCreator = props.isCreator, creatorName = props.creatorName, datetimeInfo = props.datetimeInfo, selected = props.selected, selectable = props.selectable, onSelectWork = props.onSelectWork;
    var classes = useStyles();
    var _a = useMemo(function () {
        var subjectInfo = getDisplaySubjectInfoByDrillTypeName(1, drillType);
        return {
            DisplayIcon: (subjectInfo === null || subjectInfo === void 0 ? void 0 : subjectInfo.DisplayIcon) || undefined,
            subjectTheme: (subjectInfo === null || subjectInfo === void 0 ? void 0 : subjectInfo.subjectTheme) || undefined,
        };
    }, [drillType]), DisplayIcon = _a.DisplayIcon, subjectTheme = _a.subjectTheme;
    var handleOpenWorkPreview = useCallback(function (event) {
        window.open(pathToWorkPreview(id.toString()), '_blank');
        event.preventDefault();
    }, [id]);
    var handleClickCheckbox = useCallback(function (event) {
        event.stopPropagation();
        onSelectWork();
    }, [onSelectWork]);
    if (!DisplayIcon)
        return null;
    return (React.createElement(Card, { className: classes.root, onClick: handleOpenWorkPreview },
        React.createElement("div", { className: classes.content },
            React.createElement("div", { className: classes.subjectMark, style: { backgroundColor: subjectTheme === null || subjectTheme === void 0 ? void 0 : subjectTheme.tertiary } }, DisplayIcon && React.createElement(DisplayIcon, { style: { color: subjectTheme === null || subjectTheme === void 0 ? void 0 : subjectTheme.primary } })),
            React.createElement("div", { className: classes.title },
                React.createElement("span", { className: classes.titleSpan },
                    React.createElement(Typography, { variant: "body1", bold: true }, name))),
            React.createElement("div", { className: classes.info },
                React.createElement("div", { className: classes.infoRow },
                    React.createElement(Typography, { variant: "caption", noWrap: true, align: 'right', className: classes.infoLabel }, isCreator ? '' : '作成者'),
                    React.createElement(Typography, { variant: "caption", noWrap: true, align: 'left', className: classes.infoValue }, isCreator ? '' : "" + creatorName)),
                React.createElement("div", { className: classes.infoRow },
                    React.createElement(Typography, { variant: "caption", noWrap: true, align: 'right', className: classes.infoLabel }, "" + datetimeInfo.label),
                    React.createElement(Typography, { variant: "caption", noWrap: true, align: 'left', className: classes.infoValue }, "" + datetimeInfo.datetime))),
            React.createElement("div", { className: classes.checkbox },
                React.createElement(Checkbox, { value: selected, onClick: handleClickCheckbox, disabled: !selectable && !selected })))));
});
